/**
 * Word-exported HTML wraps its CSS in HTML comments (`<style><!-- ... --></style>`),
 * which DOMPurify treats as suspicious and removes along with the styles.
 * Strip those comment markers inside <style> blocks only so formatting survives
 * sanitization. This does not bypass sanitization: the result still goes
 * through DOMPurify.sanitize() (see SanitizedHtmlDirective).
 */
export function stripStyleComments(html: string): string {
  return (html ?? '').replace(
    /(<style[^>]*>)([\s\S]*?)(<\/style>)/gi,
    (_m, open: string, css: string, close: string) => open + css.replace(/<!--|-->/g, '') + close,
  );
}
